import Region from '../../services/region'
import * as types from '../mutationTypes'

let state = {
  error: null,
  regions: [],
  region: null,
  headers: [
    { text: 'ID', value: 'id' },
    { text: 'Region', value: 'name' },
    { text: 'Hydro Id', value: 'hydroId' }
  ]
}

const getters = {
  selectList (state) {
    return state.regions.map(region => {
      return { text: region.name, value: region.id }
    })
  },
  regions (state) {
    return state.regions
  },
  headers () {
    return state.headers
  }
}

const actions = {
  async loadRegions ({ commit }) {
    try {
      let res = await Region.getActive()
      if (res) {
        commit(types.REQUEST_GET_REGION_SUCCESS, res.data)
      }
    } catch (err) {
      commit(types.REQUEST_GET_REGION_ERROR, err.message + ' Error getting regions')
    }
  }
}

const mutations = {
  [types.REQUEST_GET_REGION_SUCCESS] (state, data) {
    state.regions = data
  },
  [types.REQUEST_GET_REGION_ERROR] (state, message) {
    state.error = message
    state.regions = []
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
